export { RoleDetailPanel } from "./role-detail";
